import React, { useEffect, useState } from 'react';
import { FiTruck, FiCheckCircle, FiXCircle } from 'react-icons/fi';
import { TbCrane } from 'react-icons/tb';
import BottomNavigationCustomer from './BottomNavigatonCustomer';
import DriverStatusTracking from '../VendorResponsesCustomer/DriverStatusTracking';
import HistoryDetails from '../VendorResponsesCustomer/HistoryDetails';
import CancelledOrders from '../VendorResponsesCustomer/CancelledOrders';
import './ActivityPage.css';

const ActivityPage = () => {
    const [selectedFilter, setSelectedFilter] = useState('completed');
    const [currentService, setCurrentService] = useState('recoveryVan');

    useEffect(() => {
        localStorage.setItem('currentService', currentService);
    }, [currentService]);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="font-satoshi cp-activity">

            {/* ============ HEADER ============ */}
            <header className="cp-header cp-header--sub">
                <div className="cp-header-logo">
                    <img src="https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/navbar/logo-navbar-compressed.png" alt="ClaimPro" />
                </div>
            </header>

            {/* ============ PAGE HERO ============ */}
            <section className="cp-page-hero">
                <p className="cp-page-hero-eyebrow">Stay In The Loop</p>
                <h1 className="cp-page-hero-title">Your Updates</h1>
                <p className="cp-page-hero-sub">
                    Track live requests and browse your service history.
                </p>
            </section>

            <div className="cp-activity-body">

                {/* ============ LIVE TRACKING ============ */}
                <section className="cp-activity-tracking">
                    <DriverStatusTracking />
                </section>

                {/* ============ SERVICE TYPE FILTER ============ */}
                <div className="service-heading">
                    <p>Service History</p>
                </div>

                <div className="cp-segment cp-segment--service">
                    <button
                        type="button"
                        className={`cp-segment-btn ${currentService === 'recoveryVan' ? 'active' : ''}`}
                        onClick={() => setCurrentService('recoveryVan')}
                    >
                        <FiTruck size={14} />
                        Recovery Van
                    </button>
                    <button
                        type="button"
                        className={`cp-segment-btn ${currentService === 'crane' ? 'active' : ''}`}
                        onClick={() => setCurrentService('crane')}
                    >
                        <TbCrane size={15} />
                        Crane
                    </button>
                </div>

                {/* ============ COMPLETED / CANCELLED FILTER ============ */}
                <div className="cp-segment cp-segment--status">
                    <button
                        type="button"
                        className={`cp-segment-btn cp-segment-btn--status ${selectedFilter === 'completed' ? 'active' : ''}`}
                        onClick={() => setSelectedFilter('completed')}
                    >
                        <FiCheckCircle size={13} />
                        Completed
                    </button>
                    <button
                        type="button"
                        className={`cp-segment-btn cp-segment-btn--status cancelled ${selectedFilter === 'cancelled' ? 'active' : ''}`}
                        onClick={() => setSelectedFilter('cancelled')}
                    >
                        <FiXCircle size={13} />
                        Cancelled
                    </button>
                </div>

                {/* ============ RESULTS ============ */}
                <section className="cp-activity-results">
                    {selectedFilter === 'completed' && (
                        <HistoryDetails currentService={currentService} />
                    )}
                    {selectedFilter === 'cancelled' && (
                        <CancelledOrders currentService={currentService} />
                    )}
                </section>

            </div>

            <BottomNavigationCustomer />
        </div>
    );
};

export default ActivityPage;